import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Comprehensive list of MusicKit errors to suppress
const MUSICKIT_ERRORS = [
  'previous descriptor',
  'previousDescriptor',
  'MEDIA_KEY',
  'MusicKit',
  'musickit',
  'music.apple.com',
  'js-cdn.music.apple.com',
  'method was called without',
  'A method was called',
  'play() request was interrupted',
  'The play() request',
  'AbortError',
  'NotAllowedError',
  'MusicUserToken',
  'missing MusicUserToken',
  'Unable to prepare media item',
  'Unable to prepare',
  'MediaKeySession'
];

const isMusicKitError = (message) => {
  if (!message) return false;
  const msgStr = message.toString().toLowerCase();
  return MUSICKIT_ERRORS.some(err => msgStr.toLowerCase().includes(err.toLowerCase()));
};

// Override window.alert to suppress MusicKit errors from showing as alerts
const originalAlert = window.alert;
window.alert = function(message) {
  if (message && isMusicKitError(message)) {
    console.warn('[Suppressed MusicKit Alert]:', message);
    return; // Don't show the alert
  }
  return originalAlert.call(window, message);
};

// Global error handler to suppress MusicKit internal errors
// These are non-actionable errors that don't affect functionality
window.addEventListener('error', (event) => {
  if (isMusicKitError(event.message) || (event.filename && event.filename.includes('music.apple.com'))) {
    console.warn('[Suppressed MusicKit Error]:', event.message);
    event.preventDefault();
    event.stopPropagation();
    return true;
  }
}, true);

// Also handle unhandled promise rejections from MusicKit
window.addEventListener('unhandledrejection', (event) => {
  const reasonStr = event.reason ? (event.reason.message || event.reason.toString()) : '';
  if (isMusicKitError(reasonStr)) {
    console.warn('[Suppressed MusicKit Promise Rejection]:', reasonStr);
    event.preventDefault();
    return;
  }
});

// Override window.onerror as early as possible
const originalOnerror = window.onerror;
window.onerror = function(message, source, lineno, colno, error) {
  if (isMusicKitError(message) || (source && source.includes('music.apple.com'))) {
    console.warn('[Suppressed via onerror]:', message);
    return true;
  }
  if (originalOnerror) {
    return originalOnerror(message, source, lineno, colno, error);
  }
  return false;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
